import React from 'react';
import { Link } from 'react-router-dom';

const Hero = ({ title, subtitle, description, buttonText, buttonLink, backgroundImage }) => {
    return (
        <section
            className="hero"
            style={backgroundImage ? {
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${backgroundImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundAttachment: 'fixed'
            } : {}}
        >
            <div className="hero-overlay"></div>
            <div className="hero-content">
                {subtitle && <p className="hero-subtitle">{subtitle}</p>}
                <h1 className="hero-title" style={{
                    background: 'linear-gradient(90deg, #069668 0%, #7dd3c0 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text'
                }}>{title}</h1>
                {description && <p className="hero-description">{description}</p>}
                {buttonText && buttonLink && (
                    <Link to={buttonLink} className="cta-button primary">
                        {buttonText}
                    </Link>
                )}
            </div>
        </section>
    );
};

export default Hero;
